import React, { useEffect } from 'react';
import usePage from '#/common/hooks/usePage';
import { PageAction } from '#/app/providers/PageProvider';

export interface PageActionsProps {
  actions: PageAction[];
}

const PageActions: React.FC<PageActionsProps> = ({ actions }) => {
  const { setActions } = usePage();
  useEffect(() => {
    setActions(actions);

    return () => {
      setActions([]);
    };
  }, [actions, setActions]);

  return <></>;
};

export default React.memo(PageActions);
